export const API_CONFIG = {
    baseUrl: "http://192.168.10.10:8080/gohome" // Inserir IP do servidor com porta e /gohome, ex.: 10.10.10.1:8080/gohome
}
